export default ({
  name,
  value
}) => ({
  ...value
    ? {
      [name]: value
    } : null
})
